import { IdentificationIcon, PhoneIcon, EnvelopeIcon } from '@heroicons/react/24/outline'
import { useTranslation } from 'react-i18next'

const CIVILITE_OPTIONS = [
  { label: 'Mr', value: 'Mr' },
  { label: 'Mme', value: 'Mme' },
]

const FieldError = ({ message }) =>
  message ? (
    <span className='block mt-1 text-xs text-red-600 font-medium'>{message}</span>
  ) : null

const AmicalAdherentForm = ({ values, errors = {}, onChange, voucherEmail }) => {
  const { t } = useTranslation()

  return (
    <div className='glass-card p-4 sm:p-6'>
      <h3 className='text-base sm:text-lg font-bold text-gradient mb-4'>
        {t('moteurReservation.amical.adherentInfo')}
      </h3>

      <div className='grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4'>
        <div>
          <label className='modern-label'>
            {t('moteurReservation.amical.civility')} <span className='text-red-500'>*</span>
          </label>
          <select
            value={values.civilite_amical || ''}
            onChange={(e) => onChange('civilite_amical', e.target.value)}
            className='modern-input'
          >
            <option value=''>{t('moteurReservation.amical.select')}</option>
            {CIVILITE_OPTIONS.map((o) => (
              <option key={o.value} value={o.value}>
                {o.label}
              </option>
            ))}
          </select>
          <FieldError message={errors.civilite_amical} />
        </div>

        <div>
          <label className='modern-label'>
            {t('moteurReservation.amical.matricule')} <span className='text-red-500'>*</span>
          </label>
          <div className='relative modern-input-group'>
            <IdentificationIcon className='w-5 h-5 absolute left-3 top-1/2 -translate-y-1/2 text-gray-400 pointer-events-none' />
            <input
              type='text'
              value={values.matricule_fiscal_amical || ''}
              onChange={(e) => onChange('matricule_fiscal_amical', e.target.value)}
              placeholder={t('moteurReservation.amical.matricule')}
              className='modern-input has-leading-icon !pl-10 pr-4'
            />
          </div>
          <FieldError message={errors.matricule_fiscal_amical} />
        </div>

        <div>
          <label className='modern-label'>
            {t('moteurReservation.amical.phone')} <span className='text-red-500'>*</span>
          </label>
          <div className='relative modern-input-group'>
            <PhoneIcon className='w-5 h-5 absolute left-3 top-1/2 -translate-y-1/2 text-gray-400 pointer-events-none' />
            <input
              type='tel'
              value={values.telephone_amical || ''}
              onChange={(e) => onChange('telephone_amical', e.target.value)}
              placeholder='+216 ...'
              className='modern-input has-leading-icon !pl-10 pr-4'
            />
          </div>
          <FieldError message={errors.telephone_amical} />
        </div>
      </div>

      <div className='mt-4'>
        <label className='modern-label'>{t('moteurReservation.amical.email')}</label>
        <div className='relative modern-input-group'>
          <EnvelopeIcon className='w-5 h-5 absolute left-3 top-1/2 -translate-y-1/2 text-gray-400 pointer-events-none' />
          <input
            type='email'
            value={voucherEmail || ''}
            readOnly
            disabled
            className='modern-input has-leading-icon !pl-10 bg-gray-100/70 cursor-not-allowed text-gray-600'
          />
        </div>
      </div>
    </div>
  )
}

export default AmicalAdherentForm
